import React from 'react'
import { useTranslation } from 'react-i18next';
import '../css/index.css'
export const Services = () => {
  const showReadMore=(e)=>{
    console.log(e.target);
      e.target.classList.toggle("expand");
      // e.target.childNodes[2].classList.toggle("show-content");
  }
  const { t } = useTranslation(["home"]);

  return (
    <div>
    <section className="rSec1">
        <h1>{t("services.sec1-h1")}</h1>
       <div className="groupImg"><img src={require("../assets/serviceImg.gif")} alt="service" /></div> 
    </section>
    <section className="servP rSec2">
        <h1>{t("services.sec2-h1")}</h1>
        <p>{t("services.sec2-p")}</p>
        <div className="rSubSec service-subsec">
        <div className="btns serbtns">
                <a href="#Managed-Services" className="ourService">{t("services.btnsA1")}</a>
                <a href="#Co-Managed-IT-Services" className="ourService">{t("services.btnsA2")}</a>
                <a href="#Project-Services" className="ourService">{t("services.btnsA3")}</a>
                <a href="#IT-Strategy-Services" className="ourService">{t("services.btnsA4")}</a>
            </div>
        </div>
    </section>
    <section className="service-section">
      <section name="Managed-Services" id='Managed-Services' className="services service-one">
        <div className="service-info rSec2">
          <h1>{t("service-one.heading")}</h1>
          <p>{t("service-one.desc")}</p>
        </div>
        <div className="service-data service-data-1">
          <div className="service-type rSec2">
          <h1>{t("service-one.d1-h1")}</h1>
            <strong>{t("service-one.d1-strong")}</strong>
            <p>{t("service-one.d1-p")}</p>
            <div onClick={showReadMore} className="read-more">
            <p>{t("service-one.read-more")}</p>
            <img src={require("../assets/plus.png")} alt="view more"  />
            <p className="hidden-content">{t("service-one.d1-readmore-p")}</p>
            </div>
          </div>
          <div className="service-img">
          <img src={require("../assets/service1-img1.png")} alt="service" />
          </div>
        </div>
        <div className="service-data service-data-2">
          <div className="service-type rSec2">
            <h1>{t("service-one.d2-h1")}</h1>
            <strong>{t("service-one.d2-strong")}</strong>
            <p>{t("service-one.d2-p")}</p>
            <div onClick={showReadMore} className="read-more">
            <p>{t("service-one.read-more")}</p> 
            <img src={require("../assets/plus.png")} alt="view more"  />
            <p className="hidden-content">{t("service-one.d2-readmore-p")}</p>
            </div>
          </div>
          <div className="service-img">
          <img src={require("../assets/service1-img2.png")} alt="service" />
          </div>
        </div>
        <div className="service-data service-data-3">
          <div className="service-type rSec2">
            <h1>{t("service-one.d3-h1")}</h1>
            <strong>{t("service-one.d3-strong")}</strong>
            <p>{t("service-one.d3-p")}</p>
            <div onClick={showReadMore} className="read-more">
            <p>{t("service-one.read-more")}</p> 
            <img src={require("../assets/plus.png")} alt="view more"  />
            <p className="hidden-content">{t("service-one.d3-readmore-p")}</p>
            </div>
          </div>
          <div className="service-img">
          <img src={require("../assets/service1-img3.png")} alt="service" />
          </div>
        </div>
        <div className="service-data service-data-4">
          <div className="service-type rSec2">
            <h1>{t("service-one.d4-h1")}</h1>
            <strong>{t("service-one.d4-strong")}</strong>
            <p>{t("service-one.d4-p")}</p>
            <div onClick={showReadMore} className="read-more">
            <p>{t("service-one.read-more")}</p> 
            <img src={require("../assets/plus.png")} alt="view more"  />
            <p className="hidden-content">{t("service-one.d4-readmore-p")}</p>
            </div>
          </div>
          <div className="service-img">
          <img src={require("../assets/service1-img4.png")} alt="service" />
          </div>
        </div>
          <div className="btns">
                <a href="/contact" className="getStartedBtn">{t("sec4.getStarted")}</a>
            </div>
      </section>
      <section id='Co-Managed-IT-Services' className="services service-two">
        <div className="service-info rSec2">
          <h1>{t("service-two.heading")}</h1>
          <p>{t("service-two.desc")}</p>
        </div>
        <div className="service-data service-data-1">
          <div className="service-type rSec2">
          <h1>{t("service-two.d1-h1")}</h1>
            <strong>{t("service-two.d1-strong")}</strong>
            <p>{t("service-two.d1-p")}</p>          
          </div>
          <div className="service-img">
          <img src={require("../assets/service2-img1.png")} alt="service" />
          </div>
        </div>
        <div className="service-data service-data-2">
          <div className="service-type rSec2">
            <h1>{t("service-two.d2-h1")}</h1>
            <strong>{t("service-two.d2-strong")}</strong>
            <p>{t("service-two.d2-p")}</p>
          </div>
          <div className="service-img">
          <img src={require("../assets/service2-img2.png")} alt="service" />
          </div>
        </div>
        <div className="service-data service-data-3">
          <div className="service-type rSec2">
            <h1>{t("service-two.d3-h1")}</h1>
            <strong>{t("service-two.d3-strong")}</strong>
            <p>{t("service-two.d3-p")}</p>
          </div>
          <div className="service-img">
          <img src={require("../assets/service2-img3.png")} alt="service" />
          </div>
        </div>
        <div className="service-data service-data-4">
          <div className="service-type rSec2">
            <h1>{t("service-two.d4-h1")}</h1>
            <strong>{t("service-two.d4-strong")}</strong>
            <p>{t("service-two.d4-p")}</p>
            <div onClick={showReadMore} className="read-more">
            <p>{t("service-one.read-more")}</p> 
            <img src={require("../assets/plus.png")} alt="view more"  />
            <p className="hidden-content">{t("service-two.d4-readmore-p")}</p>
            </div>
          </div>
          <div className="service-img">
          <img src={require("../assets/service2-img4.png")} alt="service" />
          </div>
        </div>
        <div className="service-data service-data-5">
          <div className="service-type rSec2">
            <h1>{t("service-two.d5-h1")}</h1>
            <strong>{t("service-two.d5-strong")}</strong>
            <p>{t("service-two.d5-p")}</p>
          </div>
          <div className="service-img">
          <img src={require("../assets/service2-img5.png")} alt="service" />
          </div>
        </div>
          <div className="btns">
                <a href="/contact" className="getStartedBtn">{t("sec4.getStarted")}</a>
            </div>
      </section>
      <section id='Project-Services' className="services service-three">
        <div className="service-info rSec2">
          <h1>{t("service-three.heading")}</h1>
          <p>{t("service-three.desc")}</p>
        </div>
        <div className="service-data service-data-1">
          <div className="service-type rSec2">
          <h1>{t("service-three.d1-h1")}</h1>
            <strong>{t("service-three.d1-strong")}</strong>
            <p>{t("service-three.d1-p")}</p>
          
          </div>
          <div className="service-img">
          <img src={require("../assets/service3-img1.png")} alt="service" />
          </div>
        </div>
        <div className="service-data service-data-2">
          <div className="service-type rSec2">
            <h1>{t("service-three.d2-h1")}</h1>
            <strong>{t("service-three.d2-strong")}</strong>
            <p>{t("service-three.d2-p")}</p>
            <div onClick={showReadMore} className="read-more">
            <p>{t("service-one.read-more")}</p> 
            <img src={require("../assets/plus.png")} alt="view more"  />
            <p className="hidden-content">{t("service-three.d2-readmore-p")}</p>
            </div>
          </div>
          <div className="service-img">
          <img src={require("../assets/service3-img2.png")} alt="service" />
          </div>
        </div>
        <div className="service-data service-data-3">
          <div className="service-type rSec2">
            <h1>{t("service-three.d3-h1")}</h1>
            <strong>{t("service-three.d3-strong")}</strong>
            <p>{t("service-three.d3-p")}</p>
          </div>
          <div className="service-img">
          <img src={require("../assets/service3-img3.png")} alt="service" />
          </div>
        </div>
        <div className="service-data service-data-4">
          <div className="service-type rSec2">
            <h1>{t("service-three.d4-h1")}</h1>
            <strong>{t("service-three.d4-strong")}</strong>
            <p>{t("service-three.d4-p")}</p>
            <div onClick={showReadMore} className="read-more">
            <p>{t("service-one.read-more")}</p> 
            <img src={require("../assets/plus.png")} alt="view more"  />
            <p className="hidden-content">{t("service-three.d4-readmore-p")}</p>
            </div>
          </div>
          <div className="service-img">
          <img src={require("../assets/service3-img4.png")} alt="service" />
          </div>
        </div>
          <div className="btns">
                <a href="/contact" className="getStartedBtn">{t("sec4.getStarted")}</a>
            </div>
      </section>
         <section id='IT-Strategy-Services' className="services service-four">
        <div className="service-info rSec2">
          <h1>{t("service-four.heading")}</h1>
          
        </div>
        <div className="service-data service-data-1">
          <div className="service-type rSec2">
          <h1>{t("service-four.d1-h1")}</h1>
            <strong>{t("service-four.d1-strong")}</strong>
            <p>{t("service-four.d1-p")}</p>
           
          </div>
          <div className="service-img">
          <img src={require("../assets/service4-img1.png")} alt="service" />
          </div>
        </div>
        <div className="service-data service-data-2">
          <div className="service-type rSec2">
            <h1>{t("service-four.d2-h1")}</h1>
            <strong>{t("service-four.d2-strong")}</strong>
            <p>{t("service-four.d2-p")}</p>
            
          </div>
          <div className="service-img">
          <img src={require("../assets/service4-img2.png")} alt="service" />
          </div>
        </div>
        <div className="service-data service-data-3">
          <div className="service-type rSec2">
            <h1>{t("service-four.d3-h1")}</h1>
            <strong>{t("service-four.d3-strong")}</strong>
            <p>{t("service-four.d3-p")}</p>
           
          </div>
          <div className="service-img">
          <img src={require("../assets/service4-img3.png")} alt="service" />
          </div>
        </div>
        <div className="service-data service-data-4">
          <div className="service-type rSec2">
            <h1>{t("service-four.d4-h1")}</h1>
            <strong>{t("service-four.d4-strong")}</strong>
            <p>{t("service-four.d4-p")}</p>
            
          </div>
          <div className="service-img">
          <img src={require("../assets/service4-img4.png")} alt="service" />
          </div>
        </div>
          <div className="btns">
                <a href="/contact" className="getStartedBtn">{t("sec4.getStarted")}</a>
            </div>
      </section> 
    </section>
    </div>
  )
}